import React from 'react'
import Layout from '../../component/Layout';
import AIFeaturesContent from '../../component/AIFeaturesContent';
import { t } from 'i18next';

const AIContainer = () => {
	return (
		<Layout title={t("ai_features")} description={t("ai_feature_desc")}>
			<AIFeaturesContent />
		</Layout>
	)
}

export default AIContainer